export default "__VITE_ASSET__76500fdd__"